import React from 'react';
import { Input } from 'reactstrap';
import PropTypes from 'prop-types';

const propTypes = {
  bsSize: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
};

const defaultProps = {
  bsSize: 'lg',
  value: 'placeholder',
  onChange: undefined,
};

const InputTime = ({ bsSize, value, onChange }) => (
  <Input type="select" defaultValue="placeholder" bsSize={bsSize} value={value} onChange={onChange}>
    <option value="placeholder" disabled>
      Hour
    </option>
    <option value="00:00">12:00 AM</option>
    <option value="01:00">1:00 AM</option>
    <option value="02:00">2:00 AM</option>
    <option value="03:00">3:00 AM</option>
    <option value="04:00">4:00 AM</option>
    <option value="05:00">5:00 AM</option>
    <option value="06:00">6:00 AM</option>
    <option value="07:00">7:00 AM</option>
    <option value="08:00">8:00 AM</option>
    <option value="09:00">9:00 AM</option>
    <option value="10:00">10:00 AM</option>
    <option value="11:00">11:00 AM</option>
    <option value="12:00">12:00 PM</option>
    <option value="13:00">1:00 PM</option>
    <option value="14:00">2:00 PM</option>
    <option value="15:00">3:00 PM</option>
    <option value="16:00">4:00 PM</option>
    <option value="17:00">5:00 PM</option>
    <option value="18:00">6:00 PM</option>
    <option value="19:00">7:00 PM</option>
    <option value="21:00">8:00 PM</option>
    <option value="21:00">9:00 PM</option>
    <option value="22:00">10:00 PM</option>
    <option value="23:00">11:00 PM</option>
    <option value="24:00">12:00 PM</option>
  </Input>
);

InputTime.propTypes = propTypes;
InputTime.defaultProps = defaultProps;

export { InputTime };



// WEBPACK FOOTER //
// ./src/business/register/components/input-time.js